import React from 'react';
import Card from '../../common/Card/Card';
import './RegulatoryCard.css';
import { Link } from 'react-router-dom';

const RegulatoryCard = ({ updates }) => {
    return (
        <Link to="/regulatorik" className="card-link">
            <Card title="Regulatorik" variant="primary" className="regulatory-card">
                <div className="ki-badge-card">
                    KI
                </div>
                <div className="regulatory-icon">💬</div>
                <div className="regulatory-content">
                    <p>Neue Anforderungen aus:</p>
                    <ul>
                        <li>Rundschreiben</li>
                        <li>Merkblätter</li>
                        <li>und anderem</li>
                    </ul>
                </div>
            </Card>
        </Link>
    );
};

export default RegulatoryCard;